import React from 'react'
import { useState } from 'react';
import axios from 'axios';
function CreateAttributeGroup() {
  const [groupname, setGroupname] = useState('');
  const [code, setCode] = useState('');
  const [sortorder, setSortorder] = useState('');
  const [description, setDescription] = useState('');
  const sendData = async (e) => {
    
    try {
      e.preventDefault();
      const formdata=new FormData();
      formdata.append('groupname',groupname);
      formdata.append('code',code);
      formdata.append('sortorder',sortorder);
      formdata.append('description',description);
      const response = await axios.post(process.env.REACT_APP_API_URL+'/api/brands', formdata)
      console.log(response);
    }
    catch (error) {
      console.error(error);
    }
  }
  return (
    <>
    <div >
      <p className='m-6'>Create Attribute Group</p>
    <form class="bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4" onSubmit={sendData}>
  <div class="mb-4">
    <label class="block text-gray-700 text-sm font-bold mb-2" for="groupname">
      Group Name
    </label>
    <input class="shadow appearance-none border rounded w-96 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" id="groupname" type="text" placeholder="Group Name" onChange={(e)=>setGroupname(e.target.value)}/>
  </div>
  <div class="mb-4">
    <label class="block text-gray-700 text-sm font-bold mb-2" for="code">
      Code
    </label>
    <input class="shadow appearance-none border rounded w-96 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" id="code" type="text" placeholder="Code" onChange={(e)=>setCode(e.target.value)} />
  </div>
  <div class="mb-4">
    <label class="block text-gray-700 text-sm font-bold mb-2" for="sortorder">
      Sort Order
    </label>
    <input class="shadow appearance-none border  w-96 py-2 px-3 text-gray-700 leading-tight focus:outline-none " id="sortorder" type="number" placeholder="Sort Order" onChange={(e)=>setSortorder(e.target.value)}/>
  </div>
  <div class="mb-6">
    <label class="block text-gray-700 text-sm font-bold mb-2" for="description">
      Description
    </label>
    <textarea class="shadow appearance-none border rounded w-2/3 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" id="description" placeholder="Description" onChange={(e)=>setDescription(e.target.value)}></textarea>
  </div>
  <div class="flex items-center justify-between">
    <button class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline" type="submit">
      Submit
    </button>
  </div>
</form>
    </div>
    </>
  )
}

export default CreateAttributeGroup